/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  error: {
    id: 'account.details.submit.error',
    defaultMessage: 'An error occurred trying to save your account details',
  },
  success: {
    id: 'account.details.submit.success',
    defaultMessage: 'Successfully updated your account details',
  },
  passworderror: {
    id: 'account.details.submit.passworderror',
    defaultMessage:
      'Something went wrong when attempting to update the password. Is the current password correct?',
  },
  validationError: {
    id: 'account.details.submit.validationerror',
    defaultMessage:
      'Invalid entry, please check that the First- and lastname are max 75 characters, the email is valid, the date of birth is valid.',
  },
  accountDetails: {
    id: 'account.details.title',
    defaultMessage: 'Account details',
  },
  addressListTitle: {
    id: 'account.addressList.title',
    defaultMessage: 'My addressbook',
  },
  addressCreateSuccess: {
    id: 'account.addressCreate.success',
    defaultMessage: 'Address created successfully',
  },
  addressEditTitle: {
    id: 'account.addressEdit.title',
    defaultMessage: 'Edit address',
  },
  addressEditSuccess: {
    id: 'account.addressEdit.success',
    defaultMessage: 'Address editted successfully',
  },
  'validation.vatId.error.regexMismatch': {
    id: 'validation.vatId.error.regexMismatch',
    defaultMessage: 'Your vatId doesn\'t match the expected format',
  },
  'validation.vatId.error.invalidVatId': {
    id: 'validation.vatId.error.invalidVatId',
    defaultMessage: 'Your vatId isn\'t valid!',
  },
  'validation.vatId.error.serviceUnavailable': {
    id: 'validation.vatId.error.serviceUnavailable',
    defaultMessage: 'We\'re unable to verify your vatId, leave it empty and you can supply it another time in your account settings',
  },
  addressEditNonExistent: {
    id: 'account.addressEdit.nonExistent',
    defaultMessage: 'There is no such address.',
  },
  addressRemovalPending: {
    id: 'account.addressRemove.pending',
    defaultMessage: 'The address is being removed.',
  },
  addressRemoveSuccess: {
    id: 'account.addressRemove.success',
    defaultMessage: 'The address was removed successfully.',
  },
  addressRemoveError: {
    id: 'account.addressRemove.error',
    defaultMessage: 'The address could not be removed.',
  },
  nl: {
    id: 'account.language.nl',
    defaultMessage: 'Nederlands',
  },
  fr: {
    id: 'account.language.fr',
    defaultMessage: 'Français',
  },
});
